console.log("tac-cookiesacceptes.js");

(function () {

  // helper : ajout de classe
  function addClass(el, className) {
    if (el && !el.classList.contains(className)) {
      el.classList.add(className);
    }
  }

  // helper : wrap element
  function wrap(el, wrapper) {
    if (!el || !wrapper) return;
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }

  // helper : closest iframe selector (fallback safe)
  function closestVideoContainer(iframe) {
    return iframe.closest(".video-container");
  }

 

  // refus Youtube
  document.addEventListener("youtube_denied", function () {
    setTimeout(function () {
      // rien pour l'instant
      // console.log("ON A DIT NON YOUTUBE");
    }, 600);
  });


  // acceptation Youtube
  document.addEventListener("youtube_loaded", function () {
    setTimeout(function () {
      document.querySelectorAll("iframe[src*='youtube']").forEach(function (iframe) {
        const container = closestVideoContainer(iframe);
        if (container) {
          container.classList.remove("refus__tarte__au__citron");
        }
      });
    }, 600);
  });


  // acceptation Vimeo
  document.addEventListener("vimeo_loaded", function () {
    setTimeout(function () {
      document.querySelectorAll("iframe[src*='vimeo']").forEach(function (iframe) {
        const wrapper = document.createElement("div");
        wrapper.className = "responsiveWrapper";
        wrap(iframe, wrapper);
      });
    }, 600);
  });


  // acceptation Dailymotion
  document.addEventListener("dailymotion_loaded", function () {
    setTimeout(function () {
      document.querySelectorAll("iframe[src*='dailymotion']").forEach(function (iframe) {
        const wrapper = document.createElement("div");
        wrapper.className = "responsiveWrapper";
        wrap(iframe, wrapper);
      });
    }, 600);
  });


  // acceptation Google Maps
  document.addEventListener("googlemapssearch_loaded", function () {
    setTimeout(function () {
      document.querySelectorAll("iframe[src*='www.google.com/maps/']").forEach(function (iframe) {
        const wrapper = document.createElement("div");
        wrapper.className = "responsiveWrapper";
        wrap(iframe, wrapper);
      });
    }, 600);
  });

})();